/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable arrow-body-style */
import { FunctionComponent } from 'react';

import { useContainer } from 'unstated-next';

import BreakoutRoomOptionsContainer from './BreakoutRoomOptionsContainer';
import BreakoutRoomCreatorOptionsBody from './components/BreakoutRoomCreatorOptionsBody';
import BreakoutRoomRowCollection from './components/BreakoutRoomRowCollection';
import { StyledPanelContainer } from './styles/styled-components';

const BreakoutRoomOptionsBody: FunctionComponent = () => {
    const { isCreator } = useContainer(BreakoutRoomOptionsContainer);

    const renderBody = () => {
        if (isCreator) {
            // TODO: build out this component to also support host breakout management
            return <BreakoutRoomCreatorOptionsBody />;
        }

        return <BreakoutRoomRowCollection />;
    };

    return (
        <>
            <StyledPanelContainer>{renderBody()}</StyledPanelContainer>
        </>
    );
};

export default BreakoutRoomOptionsBody;
